import { render, staticRenderFns } from "./CodeBtn.vue?vue&type=template&id=7bb8b2eb&scoped=true"
import script from "./CodeBtn.vue?vue&type=script&lang=js"
export * from "./CodeBtn.vue?vue&type=script&lang=js"
import style0 from "./CodeBtn.vue?vue&type=style&index=0&id=7bb8b2eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb8b2eb",
  null
  
)

export default component.exports